import type { Data } from "@puckeditor/core";

import { ComponentTree } from "@/components/page-builder/component-tree";
import { buildLayerNodes, type LayerPosition } from "./layer-data";

interface LayerNavigatorProps {
  data: Data;
  selectedId: string | null;
  hiddenIds: ReadonlySet<string>;
  lockedIds: ReadonlySet<string>;
  remoteEditorsByComponent?: ReadonlyMap<string, readonly { userId: string; displayName: string; color: string }[]>;
  onSelect: (id: string) => void;
  onReorder: (dragId: string, dropId: string, position: LayerPosition) => void;
  onVisibilityToggle: (id: string) => void;
  onLockToggle: (id: string) => void;
}

export function LayerNavigator({
  data,
  selectedId,
  hiddenIds,
  lockedIds,
  remoteEditorsByComponent,
  onSelect,
  onReorder,
  onVisibilityToggle,
  onLockToggle,
}: LayerNavigatorProps) {
  const nodes = buildLayerNodes(data);

  if (nodes.length === 0) {
    return (
      <p style={{ margin: 0, fontSize: "12px", color: "var(--color-muted-foreground)" }}>
        Add a block in the canvas to start organizing the page structure.
      </p>
    );
  }

  return (
    <ComponentTree
      nodes={nodes}
      selectedId={selectedId ?? undefined}
      hiddenIds={hiddenIds}
      lockedIds={lockedIds}
      remoteEditorsByComponent={remoteEditorsByComponent}
      onSelect={onSelect}
      onReorder={onReorder}
      onVisibilityToggle={onVisibilityToggle}
      onLockToggle={onLockToggle}
    />
  );
}
